import React from 'react';
import {Form, Grid, Icon, Segment, Divider, Header} from 'semantic-ui-react';
import {getDropdownOptions} from '../../../../common/util/dropdown';

const DealerDistribution = ({
  dealerParticipants,
  wtsDealers,
  onDealerChange,
  addDealer,
  removeDealer,
  disabled,
}) => (
  <>
    <Divider horizontal style={{'margin': '1.5rem 0'}}>
      <Header as="h4">Distribución de Concesionarios</Header>
    </Divider>
    <Grid.Row style={{'paddingTop': '0'}}>
      <Grid.Column>
        <Segment secondary style={{'maxHeight': '250px', 'overflowY': 'auto'}}>
          <Form.Dropdown
            placeholder="Agregar Concesionario Activo"
            search
            selection
            fluid
            selectOnBlur={false}
            selectOnNavigation={false}
            options={getDropdownOptions(
              (wtsDealers || []).filter((d) => !(dealerParticipants || []).find((p) => p.ruc === d.ruc)),
              'ruc',
              'description',
            )}
            onChange={(ev, data) => {
              if (data.value) {
                addDealer(ev, data);
              }
            }}
            value=""
            disabled={disabled}
          />
          {(dealerParticipants || []).map((dealer, idx) => (
            <Grid
              key={`${dealer.ruc}-${idx}`}
              verticalAlign="middle"
              style={{'borderBottom': '1px solid #ddd', 'padding': '5px 0'}}
            >
              <Grid.Column width={10} style={{'fontSize': '0.95rem'}}>
                <strong>{dealer.ruc}</strong>
                {` - ${dealer.description || dealer.nombre || ''}`}
              </Grid.Column>
              <Grid.Column width={4}>
                <Form.Input
                  type="number"
                  min={0}
                  value={dealer.count || dealer.participantes || 0}
                  onChange={(ev, {value}) => {
                    onDealerChange(idx, value);
                  }}
                  disabled={disabled}
                />
              </Grid.Column>
              <Grid.Column width={2} textAlign="right">
                {dealerParticipants.length > 1 && (
                  <Icon
                    name="trash"
                    color="red"
                    link
                    size="large"
                    disabled={disabled}
                    onClick={() => {
                      removeDealer(dealer.ruc);
                    }}
                  />
                )}
              </Grid.Column>
            </Grid>
          ))}
        </Segment>
      </Grid.Column>
    </Grid.Row>
  </>
);

export default DealerDistribution;
